import { render, staticRenderFns } from "./EditWishListPopUp.vue?vue&type=template&id=c1bee23e&scoped=true"
import script from "./EditWishListPopUp.vue?vue&type=script&lang=js"
export * from "./EditWishListPopUp.vue?vue&type=script&lang=js"
import style0 from "./EditWishListPopUp.vue?vue&type=style&index=0&id=c1bee23e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bee23e",
  null
  
)

export default component.exports